import React, { useEffect } from "react";

import { Grid, Typography, Button } from "@material-ui/core";

import { Link, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";

const Landing = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("login")) navigate("/panel/dashboard");
  }, []);

  return (
    <Grid
      container
      direction='row'
      style={{ height: "100vh", zIndex: -20000 }}
      justifyContent='center'
      alignContent='center'
      alignItems='center'
    >
      <Grid item>
        <Typography
          style={{
            fontWeight: 800,
            fontSize: 80,
          }}
        >
          این ملک چَند!
        </Typography>
        <Typography
          variant='h6'
          style={{
            fontWeight: 500,
            marginTop: 20,
          }}
          color='textSecondary'
        >
          سامانه قیمت گذاری و ارزیابی ملک
        </Typography>

        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='flex-end'
          alignContent='flex-end'
          style={{ marginTop: 10 }}
        >
          <Button
            variant='text'
            color='secondary'
            component={Link}
            to='/register'
            style={{
              width: 150,
              height: 45,
              marginLeft: 10,
            }}
          >
            ثبت نام
          </Button>
          <Button variant='contained' color='secondary' component={Link} to='/login' style={{ width: 150, height: 45 }}>
            ورود
          </Button>
        </Grid>
      </Grid>

      {/* <div
          style={{
            overflow: "hidden",
            borderRadius: 300,
            position: "fixed",
            left: 100,
            height: 500,
            width: 500,
            textAlign: "center"
          }}
        >
          <Properties
            style={{
              width: 600,
              height: 600,
              zIndex: -100,
              marginRight: "-60px",
              marginTop: "50px"
            }}
          />
        </div> */}
      {/* 
        <div
          style={{
            position: "fixed",
            left: 50,
            top: 150,
            boxShadow: "0px 120px 700px -10px #757575",
            backgroundColor: "#000000",
            height: 150,
            weight: 150
          }}
        /> */}
    </Grid>
  );
};

export default Landing;
